import { render, staticRenderFns } from "./list-item-title.vue?vue&type=template&id=45af13ab&scoped=true"
import script from "./list-item-title.vue?vue&type=script&lang=js"
export * from "./list-item-title.vue?vue&type=script&lang=js"
import style0 from "./list-item-title.vue?vue&type=style&index=0&id=45af13ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45af13ab",
  null
  
)

export default component.exports